import React from "react";
import { Rectangle, Layer } from "recharts";

const BORDER_WIDTH = 3;

export default function BalanceSankeyNode({ x, y, width, height, index, payload, containerWidth }) {
  const isOut = x + width + 6 > containerWidth;

  const isNegative = payload && payload.isNegative;

  return (
    <Layer key={`CustomNode${index}`}>
      <Rectangle
        x={x}
        y={y + BORDER_WIDTH / 2}
        width={width}
        height={height - BORDER_WIDTH}
        fill={payload && payload.color ? payload.color : "rgba(76, 51, 115, 1)"}
        stroke={payload && payload.color ? payload.color : "rgba(76, 51, 115, 1)"}
        strokeWidth={BORDER_WIDTH}
        fillOpacity={payload && payload.isOutline ? 0.5 : 1}
      />
      <text
        textAnchor={isOut ? "end" : "start"}
        x={isOut ? x - 6 : x + width + 6}
        y={y + height / 2}
        fontSize="14"
        stroke="#333"
      >
        {payload.name}
      </text>
      <text
        textAnchor={isOut ? "end" : "start"}
        x={isOut ? x - 6 : x + width + 6}
        y={y + height / 2 + 13}
        fontSize="12"
        stroke="#333"
        strokeOpacity="0.5"
      >
        {payload.value}
      </text>
    </Layer>
  );
}
